<template>
    <div class="pdf-viewer-container text-center">
      <embed :src="this.url" id="pdfFrame" width="100%" height="100%" class="scroll">
    </div>
</template>

<script>

export default {
  name: "PdfViewer",
  props: { 
    url: String,
    extension: String,
  },
};
</script>

<style scoped>
  #pdfviewer {
    height: 100%;
    background-color: red;
  }
.pdf-viewer-header {
  border: 1px solid #d6dadd;
  padding: 8px;
  border-radius: 4px;
}
.pdf-viewer-container {
  border: 1px solid black;
  position: relative;
  height: 100%;
  border: 1px solid #f0f2f5;
}
</style>